import {
	BarChartOutlined,
	CalendarOutlined,
	CheckCircleOutlined,
	ClockCircleOutlined,
	DeleteOutlined,
	DollarOutlined,
	PlusOutlined,
	ReadOutlined,
	ScheduleOutlined,
	SearchOutlined
} from '@ant-design/icons';
import { DatePicker, Select, Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
import MenuSidebarAndContainer from '../../components/MenuSidebarAndContainer/menu-sidebar-and-container.component';
import RenderTour from '../../globalHooks/use-render-global-tour';
import BaseInput from './components/base-input';
import BaseSelect from './components/base-select';
import BigNumberCard from './components/big-numbers-card';
import BigNumberContainer from './components/big-numbers-container';
import FiltrosContainer from './components/filtros-container';
import HeaderContainer from './components/header';
import TabelaContas from './components/table-contas';
import { useFetchBignumbersData } from './hooks/use-fetch-big-numbers-data';
import useFetchData from './hooks/use-fetch-data';
import Styles from './styles.module.scss';
import { vencimentoFiltroOptions } from './types/filters';
import { DashboardContasPagar } from './types/ids-dashboard';
import { widthEnum } from './types/tamanho-enum';
import useBuildTourSteps from './hooks/use-build-tour';

export default function ContasAPagar() {
	const { RangePicker } = DatePicker;

	const { aVencer, hoje, pago, total, vencida, fetchBignumbers } = useFetchBignumbersData();
	const {
		despesas,
		loadingTable,
		filters,
		page,
		contas,
		dataFimPersonalizada,
		dataInicioPersonalizada,
		setFilters,
		buildFiltersAndFetch,
		cleanFilters,
		setDataFimPersonalizada,
		setDataInicioPersonalizada,
	} = useFetchData(fetchBignumbers);
	const { steps, isTourOpen, setIsTourOpen } = useBuildTourSteps();
	const history = useHistory();

	return (
		<MenuSidebarAndContainer itemMenuSelected={14}>
			<HeaderContainer>
				<div className={Styles.container_header}>
					<h3 className={`${Styles.title} tour-relatorio-1`}>Contas a Pagar</h3>
					<div className={Styles.buttons}>
						<button className={`${Styles.reportBtn} tour-relatorio-4`} onClick={() => history.push(`/relatorio/${DashboardContasPagar.id}/${DashboardContasPagar.idSec}`)}>
							<BarChartOutlined style={{ marginRight: 6 }} rev={undefined} />
							Relatório de despesas
						</button>
						<button className={`${Styles.newBtn} tour-relatorio-2`} onClick={() => history.push('/contas-a-pagar/cadastro-despesas/')}>
							<PlusOutlined style={{ marginRight: 6 }} rev={undefined} /> Nova despesa
						</button>
						<Tooltip title="Iniciar tour do sistema">
							<button className={Styles.tourButton} onClick={() => setIsTourOpen(true)}>
								<ReadOutlined style={{ fontSize: 20, color: '#1a4da1' }} rev={undefined} />
							</button>
						</Tooltip>
					</div>
				</div>
			</HeaderContainer>
			<FiltrosContainer onSubmit={(e) => buildFiltersAndFetch(e)}>
				<BaseSelect
					labelConfig={{ label: 'Vencimento', tooltip: true, tooltipText: 'Selecione o vencimento da despesa' }}
					placeholder="Selecione o vencimento"
					value={filters.vencimento ?? undefined}
					onChange={(e) => setFilters({ ...filters, vencimento: e })}
					width={widthEnum.lg}
				>
					{vencimentoFiltroOptions.map((option) => (
						<Select.Option key={option.value} value={option.value}>
							{option.label}
						</Select.Option>
					))}
				</BaseSelect>
				{filters.vencimento === 'personalizado' && (
					<div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
						<span style={{ fontSize: '0.8em' }}>Período personalizado</span>
						<RangePicker
							onChange={(values) => {
								setDataInicioPersonalizada(values?.[0] ?? null);
								setDataFimPersonalizada(values?.[1] ?? null);
							}}
							value={[dataInicioPersonalizada, dataFimPersonalizada]}
							format="DD-MM-YYYY"
						/>
					</div>
				)}

				<BaseInput
					value={filters.dsDespesa ?? undefined}
					onChange={(e) => setFilters({ ...filters, dsDespesa: e.target.value })}
					width={widthEnum.lg}
					name="descricao"
					labelConfig={{ label: 'Pesquisar por descrição', tooltip: true, tooltipText: 'Digite o nome da despesa' }}
					type="text"
					placeholder="Pesquisar"
					icon={<SearchOutlined rev={undefined} />}
				/>
				<BaseSelect
					showSearch
					filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
					labelConfig={{ label: 'Conta', tooltip: true, tooltipText: 'Selecione a conta bancária' }}
					placeholder="Selecione a conta"
					value={filters.contaId ?? undefined}
					onChange={(e) => setFilters({ ...filters, contaId: e })}
					width={widthEnum.lg}
				>
					{contas?.map((conta) => (
						<Select.Option key={conta.id} value={conta.id}>
							{conta.descricao}
						</Select.Option>
					))}
				</BaseSelect>
				{/* <BaseSelect labelConfig={{label: 'Mais filtros'}} width={widthEnum.sm}>
					<Select.Option value="0">Todos</Select.Option>
					<Select.Option value="1">Ativo</Select.Option>
					<Select.Option value="2">Inativo</Select.Option>
				</BaseSelect> */}
				<button style={{ alignSelf: 'flex-end' }} type="submit" className={Styles.reportBtn}>
					Filtrar
				</button>
				<p className={Styles.clear} onClick={() => cleanFilters()}>
					<DeleteOutlined style={{ marginRight: 6 }} rev={undefined} />
					Limpar filtros
				</p>
			</FiltrosContainer>
			<BigNumberContainer>
				<BigNumberCard icon={<CalendarOutlined style={{ fontSize: 16 }} rev={undefined} />} label="VENCEM HOJE" value={hoje} color="#f79009" />
				<BigNumberCard icon={<ClockCircleOutlined rev={undefined} />} label="VENCIDA" value={vencida} color="#e53935" />
				<BigNumberCard icon={<ScheduleOutlined rev={undefined} />} label="A VENCER" value={aVencer} color="#f79009" />
				<BigNumberCard icon={<CheckCircleOutlined rev={undefined} />} label="PAGA" value={pago} color="#00b341" />
				<BigNumberCard icon={<DollarOutlined rev={undefined} />} label="TOTAL" value={total} />
			</BigNumberContainer>
			<TabelaContas data={despesas} loading={loadingTable} buildFiltersAndFetch={buildFiltersAndFetch} page={page} />
			<RenderTour
				steps={steps}
				isOpen={isTourOpen}
				setIsTourOpen={() => setIsTourOpen(false)}
				showBadge
			/>
		</MenuSidebarAndContainer>
	);
}
